/* unplugin-vue-components disabled */import { render } from "./communityGuidelines.vue?vue&type=template&id=2680b95e&scoped=true"
import script from "./communityGuidelines.vue?vue&type=script&lang=js"
export * from "./communityGuidelines.vue?vue&type=script&lang=js"

import "./communityGuidelines.vue?vue&type=style&index=0&id=2680b95e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2680b95e"]])

export default __exports__